import React from 'react';
import styled from 'styled-components/macro';

const TimeOfDayIndicators = (): JSX.Element => {
  return (
    <TimeContainer>
      <TimeContent>
        <TimeItemContainer>
          <TimeItem>12 AM</TimeItem>
        </TimeItemContainer>
        <TimeItemContainer>
          <TimeItem>1 AM</TimeItem>
        </TimeItemContainer>
        <TimeItemContainer>
          <TimeItem>2 AM</TimeItem>
        </TimeItemContainer>
        <TimeItemContainer>
          <TimeItem>3 AM</TimeItem>
        </TimeItemContainer>
        <TimeItemContainer>
          <TimeItem>4 AM</TimeItem>
        </TimeItemContainer>
        <TimeItemContainer>
          <TimeItem>5 AM</TimeItem>
        </TimeItemContainer>
        <TimeItemContainer>
          <TimeItem>6 AM</TimeItem>
        </TimeItemContainer>
        <TimeItemContainer>
          <TimeItem>7 AM</TimeItem>
        </TimeItemContainer>
        <TimeItemContainer>
          <TimeItem>8 AM</TimeItem>
        </TimeItemContainer>
        <TimeItemContainer>
          <TimeItem>9 AM</TimeItem>
        </TimeItemContainer>
        <TimeItemContainer>
          <TimeItem>10 AM</TimeItem>
        </TimeItemContainer>
        <TimeItemContainer>
          <TimeItem>11 AM</TimeItem>
        </TimeItemContainer>
        <TimeItemContainer>
          <TimeItem>12 PM</TimeItem>
        </TimeItemContainer>
        <TimeItemContainer>
          <TimeItem>1 PM</TimeItem>
        </TimeItemContainer>
        <TimeItemContainer>
          <TimeItem>2 PM</TimeItem>
        </TimeItemContainer>
        <TimeItemContainer>
          <TimeItem>3 PM</TimeItem>
        </TimeItemContainer>
        <TimeItemContainer>
          <TimeItem>4 PM</TimeItem>
        </TimeItemContainer>
        <TimeItemContainer>
          <TimeItem>5 PM</TimeItem>
        </TimeItemContainer>
        <TimeItemContainer>
          <TimeItem>6 PM</TimeItem>
        </TimeItemContainer>
        <TimeItemContainer>
          <TimeItem>7 PM</TimeItem>
        </TimeItemContainer>
        <TimeItemContainer>
          <TimeItem>8 PM</TimeItem>
        </TimeItemContainer>
        <TimeItemContainer>
          <TimeItem>9 PM</TimeItem>
        </TimeItemContainer>
        <TimeItemContainer>
          <TimeItem>10 PM</TimeItem>
        </TimeItemContainer>
        <TimeItemContainer>
          <TimeItem>11 PM</TimeItem>
        </TimeItemContainer>
      </TimeContent>
    </TimeContainer>
  );
};

export default TimeOfDayIndicators;

const TimeContainer = styled.div`
  align-items: flex-start;
  display: flex;
  flex: none;
  font-size: 14px;
  height: auto;
  min-width: 40px;
  overflow-y: hidden;
`;

const TimeContent = styled.div`
  box-sizing: border-box;
  font-size: 14px;
  margin-left: 32px;
  position: relative;
`;

const TimeItemContainer = styled.div`
  font-size: 14px;
  height: 60px;
  padding-right: 8px;
  position: relative;
  text-align: right;
`;

const TimeItem = styled.span`
  display: block;
  font-size: 10px;
  position: relative;
  text-align: right;
  top: 0px;
`;
